import axios, { AxiosInstance } from 'axios';
import { responseInterceptor } from '@/axios/axiosResponseInterceptor';
import {
  configureRefreshTokenInterceptor,
  configureTokenInterceptor,
  getRuntimeConfig,
} from '@hclinear/hc-linear-react';
import { handleErrorResponse } from '@/axios/axiosExceptionHandler';
import { languageLocalStorageService } from '@service/localStorage/languageLocalStorageService';

let backendClient: AxiosInstance | null = null;

export function createAxiosBackendClients(): AxiosInstance {
  if (backendClient) return backendClient;

  backendClient = axios.create({
    baseURL: getRuntimeConfig().BACKEND_URL,
    withCredentials: true,
  });

  backendClient.interceptors.request.use((config) => {
    config.headers['Accept-Language'] = languageLocalStorageService.getLanguage();
    return config;
  });

  configureTokenInterceptor(backendClient);
  configureRefreshTokenInterceptor(backendClient);

  backendClient.interceptors.response.use(responseInterceptor, handleErrorResponse);

  return backendClient;
}

export function getAxiosBackendClient(): AxiosInstance {
  if (!backendClient) {
    throw new Error(
      'Backend client not configured. Call createAxiosBackendClients() first.',
    );
  }
  return backendClient;
}
